import React, { useEffect, useState } from "react";
import { BaseDataUpdate } from "../../products/baseData/components/BaseDataUpdate";
import { Col } from "react-bootstrap";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { WorkflowStepper } from "./WorkflowStepper";
import { WorkflowService } from "../service";
import { IBaseData, IWorkflow, IWorkflowOtherData } from "../dto/IWorkflow";
import { ErrorToast } from "../../../shared/toasters/toasters";
import step3PaginationSlice from "../../../store/workflow/step3PaginationSlice";
import { Card } from "react-bootstrap";
import { t } from "i18next";

export const WorkflowStep3Edit = () => {
  const { id, productId } = useParams();
  const dispatch = useDispatch();
  const currentUser = JSON.parse(localStorage.getItem("currentUser") as string);
  const isManager = currentUser?.roles.includes("ROLE_MANAGER");
  const isAdmin = currentUser?.roles.includes("ROLE_ADMIN");
  const isCompanyAdmin = currentUser?.roles.includes("ROLE_COMPANY_ADMIN");
  const [baseData, setBaseData] = useState<IBaseData | undefined>(undefined);
  const stepPagination = useSelector(
    (state: IAllStates) => state.step3Pagination as any
  );
  const [currentWorkflow, setCurrentWorkflow] = useState<IWorkflow | null>(
    null
  );

  const handlePerPage = (e: any) => {
    dispatch(
      step3PaginationSlice.actions.setStep3Pagination({
        ...(stepPagination as any),
        page: 1,
        perPage: e.value,
      })
    );
  };
  const changeFilterHandler = (name: string, value: string) => {
    dispatch(
      step3PaginationSlice.actions.setStep3Pagination({
        ...(stepPagination as any),
        page: 1,
        [name]: value,
      })
    );
  };
  useEffect(() => {
    WorkflowService.getWorkflowProducts(stepPagination, +id!)
      .then((response) => {
        const { data } = response;
        const { baseData, workflow } =
          (response as unknown as IWorkflowOtherData)?.otherData ?? {};
        setBaseData(baseData);
        setCurrentWorkflow(workflow as IWorkflow);
      })
      .catch((error) => ErrorToast(error));
  }, []);
  return (
    <>
      <Card>
        <Card.Body>
          <Col xs={12}>
            <div className="row">
              <WorkflowStepper
                stepPagination={stepPagination}
                step={"BASE_DATA"}
                // setSelectedProductId={setSelectedProductId}
                status={stepPagination?.status}
                showNextButton
                precent={baseData?.percent}
                showMarkAsComplete={
                  currentWorkflow?.status === "BASE_DATA" &&
                  (isAdmin || isCompanyAdmin || isManager)
                }
                changeFilterHandler={changeFilterHandler}
                id={id}
                handlePerPage={handlePerPage}
                showFilters={false}
              />
              <div className="card bg-light overflow-hidden shadow-none">
                <div className="card-body">
                  <div className="d-flex">
                    <div className="flex-grow-1">
                      <h6 className="mb-0">
                        {`${t("workflow.current")}`}:{" "}
                        <b className="text-success">
                          {baseData?.percent ?? 0}%
                        </b>
                      </h6>
                    </div>
                    <div className="flex-shrink-0">
                      <h6 className="mb-0">
                        {baseData?.done ?? 0}/{baseData?.total ?? 0}{" "}
                        {`${t("workflow.finished")}`}
                      </h6>
                    </div>
                  </div>
                </div>
                <div className="progress">
                  {/*//@ts-ignore*/}
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${baseData?.percent ?? 0}%` }}
                    aria-valuenow={baseData?.percent as number}
                    aria-valuemin="0"
                    aria-valuemax="100"
                  />
                </div>
              </div>
              <BaseDataUpdate
                isWorkflowUpdate={true}
                selectedProductId={productId as any}
              />
            </div>
          </Col>
        </Card.Body>
      </Card>
    </>
  );
};
